import { axios } from "../config/axios";
import { ITripType } from "./../interfaces/endpoints/trips/Trips.types";
// import { getAllTripsParamsType } from "../interfaces/endpoints/trips/ITrips.sevice";
import { IBulkEditTripsWorkingDaysRequest, IBulkEditTripsWorkingDaysResponse, IBulkNotifyTripsChangeRequest, IBulkUpdateTripsTimesRequest, IBulkUpdateTripsTimesResponse } from "../interfaces/endpoints/trips/IBulkEditTripsWorkingDays";
import { IEditTrips } from "../interfaces/endpoints/trips/IEditTrip";
import { ITripChangeNotification, ITripUpdateResponse } from "../interfaces/endpoints/trips/TripChangeNotification";
import { ITrips } from "../interfaces/endpoints/trips/Trips.types";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { serialize } from "../utils/serializeToQueryString";

export type getAllTripsParamsType = {
  pageIndex: number;
  searchKeyword?: string;
  lineId?: number;
};

export const getAllTrips = async (
  att: getAllTripsParamsType
): Promise<IAxiosResponse<ITrips>> => {
  return axios.get<ITrips>(`route/TripsByOperator${serialize(att)}`);
};
export const getCurrentTrip = async (
  id: number
): Promise<IAxiosResponse<ITripType>> => {
  return axios.get<ITripType>(`route/trip/${id}`);
};
export const editTrip = async (
  body: IEditTrips
): Promise<IAxiosResponse<ITripUpdateResponse>> => {
  return axios.post("Route/EditTrip", body);
};
export const deleteTrip = async (id: number): Promise<boolean> => {
  return axios.delete(`Route/DeleteTrip/${id}`);
};
export const postTrip = async (
  body: ITripType
): Promise<IAxiosResponse<number>> => {
  return axios.post("Route/PostTrip", body);
};

export const getAffectedReservationsPreview = async (
  tripId: number
): Promise<IAxiosResponse<ITripType>> => {
  return axios.get<ITripType>(`Route/Trip/${tripId}`);
};

// previousDurationMinutes is the value EditTrip returned (the trip's length before the
// edit). The server needs it to recognise an arrival-only change; omit it and a
// length-only edit looks like "no change" to the notifier.
export const notifyTripChangeEmails = async (
  tripId: number,
  reservationIds?: string[],
  previousDurationMinutes?: number
): Promise<IAxiosResponse<boolean>> => {
  const query =
    typeof previousDurationMinutes === "number" ? `?previousDurationMinutes=${previousDurationMinutes}` : "";
  return axios.post(`Route/NotifyTripChangeEmails/${tripId}${query}`, reservationIds);
};

export const getTripDeletePreview = async (
  tripId: number
): Promise<IAxiosResponse<ITripChangeNotification>> => {
  return axios.get(`Route/PreviewTripDeleteAffected/${tripId}`);
};

export const notifyTripDeleteEmails = async (
  tripId: number,
  reservationIds?: string[]
): Promise<IAxiosResponse<boolean>> => {
  return axios.post(`Route/NotifyTripDeleteEmails/${tripId}`, reservationIds);
};

export const getTripsByLine = async (
  lineId: number
): Promise<IAxiosResponse<ITripType[]>> => {
  return axios.get<ITripType[]>(`Route/Trips/${lineId}`);
};

export const bulkEditTripsWorkingDays = async (
  body: IBulkEditTripsWorkingDaysRequest
): Promise<IAxiosResponse<IBulkEditTripsWorkingDaysResponse>> => {
  return axios.post("Route/BulkEditTripsWorkingDays", body);
};

export const bulkUpdateTripsTimes = async (
  body: IBulkUpdateTripsTimesRequest
): Promise<IAxiosResponse<IBulkUpdateTripsTimesResponse>> => {
  return axios.post("Route/BulkUpdateTripsTimes", body);
};

export const notifyBulkTripsChangeEmails = async (
  body: IBulkNotifyTripsChangeRequest
): Promise<IAxiosResponse<boolean>> => {
  return axios.post("Route/NotifyBulkTripsChangeEmails", body);
};
